/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SAPFiscalIdEntry } from './SAPFiscalIdEntry';
import {
    SAPFiscalIdEntryFromJSON,
    SAPFiscalIdEntryFromJSONTyped,
    SAPFiscalIdEntryToJSON,
} from './SAPFiscalIdEntry';

/**
 * Fiscal ID data returned in cart and order responses, with decrypted values.
 * @export
 * @interface SAPFiscalId
 */
export interface SAPFiscalId {
    /**
     * ISO 3166-1 alpha-2 country code for all fiscal ID entries (for example, PT, ES, or BR).
     * @type {string}
     * @memberof SAPFiscalId
     */
    sapCountry?: string;
    /**
     * List of fiscal ID entries with decrypted values.
     * @type {Array<SAPFiscalIdEntry>}
     * @memberof SAPFiscalId
     */
    sapFiscalIdEntries?: Array<SAPFiscalIdEntry>;
}

/**
 * Check if a given object implements the SAPFiscalId interface.
 */
export function instanceOfSAPFiscalId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPFiscalIdFromJSON(json: any): SAPFiscalId {
    return SAPFiscalIdFromJSONTyped(json, false);
}

export function SAPFiscalIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPFiscalId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sapCountry': !exists(json, 'sapCountry') ? undefined : json['sapCountry'],
        'sapFiscalIdEntries': !exists(json, 'sapFiscalIdEntries') ? undefined : ((json['sapFiscalIdEntries'] as Array<any>).map(SAPFiscalIdEntryFromJSON)),
    };
}

export function SAPFiscalIdToJSON(value?: SAPFiscalId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sapCountry': value.sapCountry,
        'sapFiscalIdEntries': value.sapFiscalIdEntries === undefined ? undefined : ((value.sapFiscalIdEntries as Array<any>).map(SAPFiscalIdEntryToJSON)),
    };
}

